module.exports = __webpack_public_path__ + "media/images/countrysquared/to-37a4a7092d4e6a5fbe4951a2bf6829ee.svg";